var map = {
	"./developer": 835,
	"./developer.md": 835,
	"./qa": 836,
	"./qa.md": 836,
	"./sales": 837,
	"./sales.md": 837,
	"./seo": 838,
	"./seo.md": 838,
	"./telemarketing": 839,
	"./telemarketing.md": 839
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3243;



//////////////////
// WEBPACK FOOTER
// ./src/translations/vacancies/ru ^\.\/.*$
// module id = 3243
// module chunks = 0